var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCreateButton)?_c('v-btn',{staticClass:"rounded-lg",attrs:{"height":"40","color":"primary","depressed":"","to":{
    name: _vm.nameTo || `${_vm.model.name}Item`,
    params: { [_vm.paramsName]: 'new' },
  }}},[_c('div',{staticClass:"text-none body-2 px-2"},[_vm._v(_vm._s(_vm.createButtonText || 'Создать'))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }